<template>
  <div v-if="pageCount > 1" class="">
    <p class="leading-5 text-gray-900">
      Showing
      <span class="font-medium">{{offset + 1}}</span>
      to
      <span class="font-medium">{{offset + recordsCount}}</span>
      of
      <span class="font-medium">{{ totalCount || 0 }}</span>
      {{tag}}
    </p>
    <paginate
        v-model=page
        :page-count=pageCount
        :click-handler="clickHandler"
        :prev-text="'«'"
        :next-text="'»'"
        :force-page="10"
        :first-last-button=false
        :hide-prev-next=true
        :no-li-surround=true
        :prev-class="'relative inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150'"
        :active-class="'relative text-teal-500 inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150'"
        :next-class="'relative inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150'"
        :page-link-class="'-ml-px relative inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150'"
        :prev-link-class="'-ml-px relative inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150'"
        :next-link-class="'-ml-px relative inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150'"
        :container-class="'pagination'">
    </paginate>
  </div>
</template>

<script>
import paginate from 'vuejs-paginate'

export default {
  name: "Pagination",
  components: {paginate},
  data() {
    return {
      page: this.currentPage
    }
  },
  props: {
    offset: Number,
    recordsCount: Number,
    tag: String,
    clickHandler: Function,
    currentPage: Number,
    recordsPerPage: Number,
    totalCount: Number
  },
  computed: {
    pageCount: function () {
      return Math.floor(this.totalCount / this.recordsPerPage) + (this.totalCount % this.recordsPerPage !== 0 ? 1 : 0)
    }
  }
}
</script>

<style scoped>

</style>